<template>
  <div class="Settings">
    <div class="title">
      <div class="title">
        <h2 class="light">
          Settings
        </h2>
      </div>
    </div>

    <div class="container">
      <div
        class="panel profile"
        v-for="pt of ptsList"
        :key="pt.id">
        <h4>Personalia & billing details</h4>
        <form
          @submit.prevent="save(pt)"
          :class="{ noedit: !edit }">
          <div class="form-group">
            <label>First name</label>
            <div
              v-if="!edit"
              class="input">
              {{ pt.firstName }}
            </div>
            <input
              v-if="edit"
              type="text"
              v-model="pt.firstName">
          </div>
          <div class="form-group">
            <label>Last name</label>
            <div
              v-if="!edit"
              class="input">
              {{ pt.lastName }}
            </div>
            <input
              v-if="edit"
              type="text"
              v-model="pt.lastName">
          </div>
          <div class="form-group">
            <label>Birthdate</label>
            <div
              v-if="!edit"
              class="input">
              {{ pt.birthdate }}
            </div>
            <input
              v-if="edit"
              type="date"
              v-model="pt.birthdate">
          </div>

          <div class="form-group">
            <label>Email</label>
            <div
              v-if="!edit"
              class="input">
              {{ pt.email }}
            </div>
            <input
              v-if="edit"
              type="email"
              v-model="pt.email">
          </div>

          <div class="form-group">
            <label>Mobile</label>
            <div
              v-if="!edit"
              class="input">
              {{ pt.mobilePrefix }} {{ pt.mobileNumber }}
            </div>
            <div class="mobile">
              <input
                class="prefix"
                v-if="edit"
                v-model="pt.mobilePrefix">
              <input
                v-if="edit"
                v-model="pt.mobileNumber">
            </div>
          </div>

          <div class="form-group">
            <label>Organization NO</label>
            <div
              v-if="!edit"
              class="input">
              {{ pt.companyRegistrationNumber }}
            </div>
            <input
              v-if="edit"
              v-model="pt.companyRegistrationNumber">
          </div>

          <div class="form-group">
            <label>Company Name</label>
            <div
              v-if="!edit"
              class="input">
              {{ pt.companyName }}
            </div>
            <input
              v-if="edit"
              v-model="pt.companyName">
          </div>

          <div class="form-group">
            <label>Address</label>
            <div
              v-if="!edit"
              class="input">
              {{ pt.addressStreet }}
            </div>
            <input
              v-if="edit"
              v-model="pt.addressStreet"
              autocomplete="street-address">
          </div>

          <div class="form-group">
            <label>Postal code</label>
            <div
              v-if="!edit"
              class="input">
              {{ pt.addressPostalCode }}
            </div>
            <input
              v-if="edit"
              v-model="pt.addressPostalCode"
              autocomplete="postal-code">
          </div>

          <div class="form-group">
            <label>Postal location</label>
            <div
              v-if="!edit"
              class="input">
              {{ pt.addressPostalLocation }}
            </div>
            <input
              v-if="edit"
              v-model="pt.addressPostalLocation"
              autocomplete="address-level1">
          </div>

          <div class="actions">
            <IconButton
              icon="edit"
              v-if="!edit"
              class="medium"
              @click="edit = true">
              Edit personalia and billing details
            </IconButton>
            <IconButton
              v-if="edit"
              class="btn"
              icon="save"
              @click="savePT(pt)">
              Save
            </IconButton>
          </div>
        </form>
      </div>

      <div
        class="panel acl"
        v-for="acl of accessControlsList"
        :key="acl.id">
        <h2>{{ acl.type }}</h2>
        <div class="form-group">
          <label>Code</label>
          <div class="input">
            {{ acl.code }}
          </div>
        </div>
        <div class="form-group">
          <label>Valid from</label>
          <div class="input">
            {{ acl.validFrom }}
          </div>
        </div>
        <div class="form-group">
          <label>Valid to</label>
          <div class="input">
            {{ acl.validTo }}
          </div>
        </div>
      </div>

      <!-- <div -->
      <!--   class="panel" -->
      <!--   v-for="pt of ptsList" -->
      <!--   :key="'billing' + pt.id"> -->
      <!--   <h4>Payment method</h4> -->
      <!--   <BillingInformation /> -->
      <!-- </div> -->
    </div>
  </div>
</template>

<script>
import gql from "graphql-tag";
// import BillingInformation from "@/components/BillingInformation";

export default {
  // components: { BillingInformation },
  data: function () {
    return {
      edit: false,
      ptsList: [],
      accessControlsList: [],
    };
  },

  methods: {
    savePT(pt) {
      this.$apollo.mutate({
        mutation: gql`
          mutation(
            $birthdate: Date!
            $email: String!
            $firstName: String!
            $lastName: String!
            $mobileNumber: String!
            $mobilePrefix: String!
            $companyRegistrationNumber: String!
            $companyName: String!
            $addressStreet: String!
            $addressPostalCode: String!
            $addressPostalLocation: String!
          ) {
            updatePt(
              input: {
                _birthdate: $birthdate
                _email: $email
                _firstName: $firstName
                _lastName: $lastName
                _mobileNumber: $mobileNumber
                _mobilePrefix: $mobilePrefix
                _companyRegistrationNumber: $companyRegistrationNumber
                _companyName: $companyName
                _addressPostalCode: $addressPostalCode
                _addressPostalLocation: $addressPostalLocation
                _addressStreet: $addressStreet
              }
            ) {
              results {
                birthdate
                email
                firstName
                id
                lastName
                mobileNumber
                mobilePrefix
                companyRegistrationNumber
                companyName
                addressStreet
                addressPostalCode
                addressPostalLocation
              }
            }
          }
        `,
        variables: pt,
      });
      this.edit = false;
    },
  },

  apollo: {
    ptsList: gql`
      query {
        ptsList {
          id
          birthdate
          createdAt
          email
          firstName
          lastName
          mobileNumber
          mobilePrefix
          beginDate
          endDate
          companyRegistrationNumber
          companyName
          addressStreet
          addressPostalCode
          addressPostalLocation
        }
      }
    `,
    accessControlsList: gql`
      query {
        accessControlsList {
          code
          createdAt
          id
          ptId
          type
          validFrom
          validTo
        }
      }
    `,
  },
};
</script>

<style lang="scss" scoped>
.Settings {
  .container {
    display: flex;
    justify-content: space-around;
    align-items: flex-start;
    padding: 1em;
    flex-wrap: wrap;
  }

  .panel {
    margin: 1em;
  }

  .noedit {
    label {
      font-weight: bold;
    }

    .form-group {
      flex-direction: row;
      justify-content: space-between;
      align-items: baseline;

      label,
      .input {
        flex: 1;
      }
    }
  }

  .acl {
    h2 {
      text-transform: uppercase;
    }

    .form-group {
      flex-direction: row;
    }
  }

  button {
    align-self: flex-end;
  }

  .input {
    padding: 1em;
  }

  .mobile {
    display: flex;
  }

  .prefix {
    width: 3em;
    flex: auto;
  }

  .actions {
    display: flex;
    justify-content: flex-end;
  }
}
</style>
